/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ConstructionType } from './constructionType';

/**
 * (german: Aufbauart)   (bipro-fahrzeug::Aufbauart)
 */
export interface ConstructionKind {
  constructionType?: ConstructionType;
}
export namespace ConstructionKind {}
